<cs-header>
  <cs-header-title>{{ title }}</cs-header-title>
  <cs-header-content>
    <div class="targets-row">
      <span class="targets-label">{{ LL.mealSuggestions.targets() }}:</span>
      <nutrient-list [nutrients]="targetDisplayNutrients" state="inline-compact" [expandable]="false"
      [hideLabel]="true"></nutrient-list>
    </div>
  </cs-header-content>
</cs-header>

<cs-content>
  @if (loading) {
    <div class="spinner">
      <cs-spinner></cs-spinner>
      <cs-text-spinner textsId="@help:loading-hints.food"></cs-text-spinner>
    </div>
  }

  @if (!loading) {
    <div class="meal-cards-list">
      @for (meal of meals; track meal; let i = $index) {
        <cs-food-card [food]="$any(meal.food)" [matchPercent]="meal.match"
          [description]="meal.ingredientText" [nutrients]="meal.displayNutrients" [selectable]="true"
          [selected]="selectedMealIndex === i" (selectedChange)="handleMealSelected(i)"
          [showMenuButton]="true" [menuInTitle]="true" (menuClick)="handleMealMenu($event, meal)"
          (click)="handleMealSelected(i)">
          <div card-actions class="like-dislike-buttons">
            <cs-icon-button outlined icon="liked" [fill]="getLikeState(meal) === LikeState.Liked" (click)="handleLike(meal)"></cs-icon-button>
            <cs-icon-button outlined icon="disliked" [fill]="getLikeState(meal) === LikeState.Disliked" (click)="handleDislike(meal)"></cs-icon-button>
          </div>
        </cs-food-card>
      }
    </div>
  }
</cs-content>

<cs-page-action-buttons [showCancel]="true" (cancel)="handleCancel($event)">
  <cs-button medium primary [label]="actionButtonLabel" [disabled]="selectedMealIndex === null"
  (click)="handleAcceptSelectedMeal($event)"></cs-button>
</cs-page-action-buttons>